module.exports = __webpack_public_path__ + "static/media/coin_silver.95009622.svg";